import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=893f3f5a&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=893f3f5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893f3f5a",
  null
  
)

export default component.exports